import { createSlice } from "@reduxjs/toolkit";
import * as app_consts from "../../../constants/react_app_consts";

const initialState = {
 delete_product_unit_measurement_details: { status: "idle" },
};

export const delete_product_unit_measurement_details_Slice = createSlice({
 name: "delete_product_unit_measurement_details",
 initialState,
 reducers: {
  success_delete_product_unit_measurement_details: (state, action) => {
   state.delete_product_unit_measurement_details = { status: app_consts.SUCCESS, data: action.payload };
  },
  fail_delete_product_unit_measurement_details: (state, action) => {
   state.delete_product_unit_measurement_details = { status: app_consts.FAIL, message: action.payload };
  },
  reset_delete_product_unit_measurement_details: (state) => {
   state.delete_product_unit_measurement_details = { status: app_consts.IDLE };
  },
  loading_delete_product_unit_measurement_details: (state) => {
   state.delete_product_unit_measurement_details = { status: app_consts.LOADING };
  },
 },
});

export const { success_delete_product_unit_measurement_details, fail_delete_product_unit_measurement_details, reset_delete_product_unit_measurement_details, loading_delete_product_unit_measurement_details } =
 delete_product_unit_measurement_details_Slice.actions;

export default delete_product_unit_measurement_details_Slice.reducer;
